// extracted by mini-css-extract-plugin
export default {"sectionBanner":"SectionInfo_sectionBanner__UUy8x","sectionText":"SectionInfo_sectionText__RJAZR","imgBanner":"SectionInfo_imgBanner__Sum7r"};